import { render, staticRenderFns } from "./SeguimientoDetail.vue?vue&type=template&id=2bed9c5b"
import script from "./SeguimientoDetail.vue?vue&type=script&lang=js"
export * from "./SeguimientoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports